export default __webpack_public_path__ + "500b122c954c3006faacabd48a6a7401.png";